module.exports = __webpack_public_path__ + "img/modules_requirement_mindmap.83a56a6e.png";